import React from 'react';
import { Link } from 'react-router-dom';

import APIClient from './APIClient';

import Alert from './Alert';
import Comic from './Comic';

import './Home.css';

class Home extends React.Component {
  state = {
    comics: null,
    error: null,
  };

  componentDidMount() {
    APIClient.shared.getComics()
      .then(comics => this.setState({ comics }))
      .catch(error => this.setState({ error }))
  }

  render() {
    const comics = this.state.comics;

    let alert = null;
    if (comics !== null && comics.length === 0) {
      const message = <span>Visit your <Link to="/profile">profile</Link> to select which comics to display.</span>;
      alert = <Alert
        title="No Comics Selected"
        message={message}
        />
    }

    return (
      <div className="Home">
        {this.state.error && <Alert title="Error" message={this.state.error.message} />}
        {alert}
        {comics !== null && comics.map(comic =>
          <Comic key={comic.name} comic={comic} />
        )}
       </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js